import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import DefautProduitStep from './DefautProduitStep';
import { estPieceRapido } from 'utils/depotHelper';

class DefautProduitStepContainer extends React.Component {
    

    render() {
        return (
            <DefautProduitStep {...this.props}/>
        );
    }
}


const mapStateToProps = (state, ownProps) => {

    let rapido = false;
    let livraisonDirecte = false;

    let colisLogistiques = [];

    let piece = state.pieceGestion[ownProps.namespace].piecesGestion ? state.pieceGestion[ownProps.namespace].piecesGestion.items.find(p => p.numeroPiece === ownProps.reclamation.numeroPiece) : null;

    if (piece) {
        rapido = estPieceRapido(piece);
        livraisonDirecte = piece.modeLivraison === 'LD';

        colisLogistiques = state.colisLogistique.colisLogistiques.items;
    }

    return {
        rapido: rapido,
        livraisonDirecte: livraisonDirecte,
        colisLogistiques: colisLogistiques
    };
};

//const mapDispatchToProps = (dispatch) => ({
//});


DefautProduitStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(DefautProduitStepContainer);